import PT from 'prop-types';
import { PlayerShape } from './PlayerCell/PlayerCell.proptypes';

const GameShape = PT.arrayOf(PT.shape({
  ...PlayerShape,

  stats: PT.arrayOf(PT.shape({
    formula_option: PT.string,
    fpts: PT.number,
    stat: PT.string,
    stat_abbr: PT.string,
    stat_id: PT.number,
    stat_value_avg: PT.number,
    stat_value_max: PT.number,
    stat_value_total: PT.number,
  })),
}));

export const DataPT = PT.oneOfType([
  PT.arrayOf(GameShape),
  GameShape,
]);

const DataTablePT = {
  colGroups: PT.arrayOf(PT.shape({
    name: PT.string,
    columns: PT.arrayOf(PT.string.isRequired).isRequired,
  })),
  rowHeight: PT.string,
  teams: PT.arrayOf(PT.shape({
    id: PT.number,
    key: PT.string,
    text: PT.string,
    abbr: PT.string,
  })),
  data: PT.array,
  language: PT.string,

  // From redux-connect
  collapsed: PT.bool,
  selectedPlayers: PT.arrayOf(PT.shape(PlayerShape)),
  selectedLeague: PT.number,
};

export default DataTablePT;



// WEBPACK FOOTER //
// ./src/app/components/DataTable/PlainTable.proptypes.js